import React from 'react';
import cx from 'classnames';
import styled from '@emotion/styled';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  active?: boolean;
  hoverable?: boolean;
}

const Card: React.FunctionComponent<CardProps> = ({
  className,
  active,
  ...props
}: CardProps) => {
  const { hoverable, ...rest } = props;
  return <div className={cx('card', className, { active })} {...rest} />;
};

export interface CardGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  active?: boolean;
  disabled?: boolean;
}

const StyledCard = styled(Card)`
  border: 1px solid white;

  ${({ onClick, hoverable }: CardProps) =>
    onClick || hoverable
      ? `
    &:hover {
      cursor: pointer;
      box-shadow: 0 1px 10px 0 rgba(29, 27, 27, 0.38);
    }
  `
      : null}
`;

const CardGroup: React.FunctionComponent<CardGroupProps> = ({
  children,
  className,
  active,
  disabled,
  ...props
}: CardGroupProps) => {
  return (
    <div
      className={cx('card-group', className, { active, disabled })}
      {...props}
    >
      {children}
    </div>
  );
};

const StyledCardGroup = styled(CardGroup)`
  & > ${StyledCard} {
    &:hover {
      box-shadow: none;
    }
  }
`;

export { StyledCardGroup as CardGroup };

export default StyledCard;
